// symbols.ts
import {InjectionKey} from 'vue';
import {UseVorderComponentReturn} from "@/components/Shop/VOrder/hooks";

export const VOrderComponentInject: InjectionKey<UseVorderComponentReturn> = Symbol('vorder:component');
